(() => {
  const OPENAI_ADS_PIXEL_ID = 'SGepqk5kwPTWKN9FGs3ZF3';
  if (window.octarineOpenAIAds) return;
  const configElement = document.getElementById('octarine-openai-ads-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  let initialized = false;
  let pageSent = false;
  let quantities = new Map(config.cartItems.map(item => [item.key, item.quantity]));

  function permissions() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return {
        allowed: privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true,
        optOut: privacy?.saleOfDataAllowed() !== true
      };
    } catch (_) { return { allowed: false, optOut: true }; }
  }

  function initialize() {
    if (initialized) return;
    if (!window.oaiq) {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      document.head.appendChild(script);
    }
    window.oaiq('consent', false);
    window.oaiq('init', { pixelId: OPENAI_ADS_PIXEL_ID });
    initialized = true;
  }

  function measure(name, data) {
    try {
      const permission = permissions();
      if (!permission.allowed) return;
      initialize();
      window.oaiq('consent', true);
      window.oaiq('measure', name, data, { opt_out: permission.optOut });
    } catch (_) {}
  }

  function added(item, quantity) {
    const price = Number(item.final_price ?? item.price);
    if (!Number.isInteger(quantity) || quantity <= 0 || !Number.isInteger(price) || price < 0) return;
    measure('items_added', {
      type: 'contents', currency: config.currency, amount: price * quantity,
      contents: [{ id: String(item.variant_id ?? item.id), content_type: 'product', quantity, amount: price, currency: config.currency }]
    });
  }

  window.octarineOpenAIAds = {
    addedItem(item, requestedQuantity) {
      try {
        if (item.status || !item.key || !Number.isInteger(item.quantity)) return;
        const previous = quantities.get(item.key) ?? 0;
        const delta = Math.min(item.quantity - previous, requestedQuantity);
        quantities.set(item.key, item.quantity);
        added(item, delta);
      } catch (_) {}
    },
    cartChanged(cart) {
      try {
        if (cart.errors || !Array.isArray(cart.items)) return;
        const previous = quantities;
        quantities = new Map(cart.items.map(item => [item.key, item.quantity]));
        for (const item of cart.items) added(item, item.quantity - (previous.get(item.key) ?? 0));
      } catch (_) {}
    }
  };

  function syncConsent() {
    try {
      const permission = permissions();
      if (!permission.allowed) {
        if (initialized) window.oaiq('consent', false);
        return;
      }
      initialize();
      window.oaiq('consent', true);
      if (!pageSent) {
        measure('page_viewed', { type: 'contents', contents: [{ id: window.location.pathname, content_type: 'page' }] });
        if (config.product) measure('contents_viewed', {
          type: 'contents', currency: config.currency,
          contents: [{ ...config.product, content_type: 'product', currency: config.currency }]
        });
        pageSent = true;
      }
    } catch (_) {}
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) syncConsent();
      });
    } catch (_) {}
  }
})();
